import { render, staticRenderFns } from "./BusinessAddress.vue?vue&type=template&id=28d6698c&scoped=true"
import script from "./BusinessAddress.vue?vue&type=script&lang=js"
export * from "./BusinessAddress.vue?vue&type=script&lang=js"
import style0 from "./BusinessAddress.vue?vue&type=style&index=0&id=28d6698c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d6698c",
  null
  
)

export default component.exports